

























import { Component, Vue, Prop, Emit,Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'

export type SpecType = {
  // id: Math.random(), // 换成接口获取id，后续可直接用于保存
  id: number | undefined,
  name: string ,
  specItemList: Array<any> ,
  sort: number
}

@Component({
  components: {}
})
export default class GoodsSpecifications extends Vue {
  @Prop({ type: Array, default:(): Array<SpecType> => [] }) private value!: Array<SpecType>

  // 规格类型 使用计算属性做伪双向绑定
  private get specTypeList(){
    return this.value
  }
  private set specTypeList(newValue){
    this.$emit('input', newValue);
  }

  private maxSpec = 3 // 最大规格类型
  private specList: Array<any> = [
    { label: '颜色', value: '颜色',disabled:false },
    { label: '规格', value: '规格',disabled:false }
  ]

  // 清理参数
  public clearParam(): void{
    this.specList.forEach(e=>{
      e.disabled = false
    })
  }

  @Watch('specTypeList',{deep:true})
  private specTypeListWatch(){
    this.specTypeChange()
  }

  // 添加规格项
  private addSpecItem(type: any) {
    type.specItemList.push({
      name: type.tempSpecItemName
    })
    type.tempSpecItemName = undefined
  }

  private deleteSpecItem(type: any, specItem: any) {
    const index = type.specItemList.indexOf(specItem)
    type.specItemList.splice(index, 1)
  }
  private addSpecType() {
    this.specTypeList.push({
      id: undefined, // 换成接口获取id，后续可直接用于保存
      name: '',
      specItemList: [],
      sort: this.specTypeList.length
    })
  }
  // 规格位置移动
  private spectTypeSort(specType: any, moveNumber: number) {
    const currentSort = specType.sort
    const tagSort = currentSort + moveNumber
    const t = this.specTypeList.filter((e) => e.sort == tagSort)
    t[0].sort = currentSort
    this.specTypeList.sort((a, b) => a.sort - b.sort)
  }
  private deleteSpecType(specType: any) {
    // 判断是否是需要提示
    if (specType.specItemList.length > 0) {
      this.$confirm('确认删除该规格吗？', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const index = this.specTypeList.indexOf(specType)
          this.specTypeList.splice(index, 1)
        })
    } else {
      const index = this.specTypeList.indexOf(specType)
      this.specTypeList.splice(index, 1)
    }
  }

  private specTypeChange(){
    // 判断 specList 是否需要禁用
    this.specList.forEach((e: any)=>{
      const tl = this.specTypeList.filter(i=>i.name == e.value)
      if(tl.length > 0){
        e.disabled = true
      } else {
        e.disabled = false
      }
    })
  }
}
